import React from 'react';
import { CardMedia } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { ActionTemplate } from '../types';

export const ActionTemplateCardImage = ({ actionTemplate }: { actionTemplate: ActionTemplate }) => {
  const templateLink = `/actions/template/${actionTemplate.id}`;
  return (
    <Link to={templateLink} style={{ textDecoration: 'none' }}>
      <CardMedia
        style={{ height: 200, cursor: 'pointer' }}
        image={actionTemplate.bannerImage || 'https://placehold.co/1920x1031?text=No+Image'}
        title={actionTemplate.title}
      />
    </Link>
  );
};
